import React, { useEffect } from 'react';
import $ from 'jquery';
// import loadScript from '../../../Helpers/LoadScript';
const Index = () => {
    useEffect(() => {
        (async () => {
            // await loadScript('./js/jquery.min.js');
            // await loadScript('./js/jquery-ui.min.js');
            // await loadScript('./js/fabric.min.js');
            // await loadScript('./js/FancyProductDesigner-all.min.js');
        })();
    }, []);
    return (
        <div>
            <div
                id="clothing-designer"
                className="
                fpd-container
                fpd-shadow-2
                fpd-topbar
                fpd-tabs
                fpd-tabs-side
                fpd-top-actions-centered
                fpd-bottom-actions-centered
                fpd-views-inside-left
            "
            ></div>
            <br />
            <div className="fpd-clearfix" style={{ marginTop: '30px' }}>
                <div className="api-buttons fpd-container fpd-left">
                    <a href="#" id="print-button" className="fpd-btn">
                        Print
                    </a>
                    <a href="#" id="image-button" className="fpd-btn">
                        Create Image
                    </a>
                    <a href="#" id="checkout-button" className="fpd-btn">
                        Checkout
                    </a>
                    <a href="#" id="recreation-button" className="fpd-btn">
                        Recreate product
                    </a>
                </div>
                <div className="fpd-right">
                    <span className="price badge badge-inverse">
                        <span id="thsirt-price"></span> $
                    </span>
                </div>
            </div>
            <p className="fpd-container">
                Only working on a webserver:
                <br />
                <span className="fpd-btn" id="save-image-php">
                    Save image with php
                </span>
                <span className="fpd-btn" id="send-image-mail-php">
                    Send image to mail
                </span>
            </p>
            {/* <script defer>
                {$(document).ready(function () {
                    var $yourDesigner = $('#clothing-designer'),
                        pluginOpts = {
                            productsJSON: './json/products_categories.json', //see JSON folder for products sorted in categories
                            designsJSON: './json/designs.json', //see JSON folder for designs sorted in categories
                            stageWidth: 1200,
                            editorMode: false,
                            smartGuides: true,
                            //uiTheme: 'doyle',
                            fonts: [
                                { name: 'Helvetica' },
                                { name: 'Times New Roman' },
                                { name: 'Pacifico', url: 'Enter_URL_To_Pacifico_TTF' },
                                { name: 'Arial' },
                                { name: 'Lobster', url: 'google' },
                            ],
                            customTextParameters: {
                                colors: false,
                                removable: true,
                                resizable: true,
                                draggable: true,
                                rotatable: true,
                                autoCenter: true,
                                boundingBox: 'Base',
                                curvable: true,
                            },
                            customImageParameters: {
                                draggable: true,
                                removable: true,
                                resizable: true,
                                rotatable: true,
                                colors: '#000',
                                autoCenter: true,
                                boundingBox: 'Base',
                            },
                            actions: {
                                top: ['download', 'print', 'snap', 'preview-lightbox'],
                                right: ['magnify-glass', 'zoom', 'reset-product', 'qr-code', 'ruler'],
                                bottom: ['undo', 'redo'],
                                left: ['manage-layers', 'info', 'save', 'load'],
                            },
                        },
                        yourDesigner = new FancyProductDesigner($yourDesigner, pluginOpts);

                    //print button
                    $('#print-button').click(function () {
                        yourDesigner.print();
                        return false;
                    });

                    //create an image
                    $('#image-button').click(function () {
                        var image = yourDesigner.createImage();
                        return false;
                    });

                    //checkout button with getProduct()
                    $('#checkout-button').click(function () {
                        var product = yourDesigner.getProduct();
                        console.log(product);
                        return false;
                    });

                    //event handler when the price is changing
                    $yourDesigner.on('priceChange', function (evt, price, currentPrice) {
                        $('#thsirt-price').text(currentPrice);
                    });

                    //save image on webserver
                    // $('#save-image-php').click(function () {
                    //     yourDesigner.getProductDataURL(function (dataURL) {
                    //         $.post('php/save_image.php', { base64_image: dataURL });
                    //     });
                    // });

                    //send image via mail
                    // $('#send-image-mail-php').click(function () {
                    //     yourDesigner.getProductDataURL(function (dataURL) {
                    //         $.post('php/send_image_via_mail.php', { base64_image: dataURL });
                    //     });
                    // });
                })}
            </script> */}
        </div>
    );
};

export default Index;
